module.exports = __webpack_public_path__ + "media/images/ticket/continue shopping_ov-477d2775bc2f129c3258810439ca920e.png";